var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTripsCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2606 16.9328V29.16C33.2605 29.2014 33.2481 29.242 33.2249 29.2764C33.2016 29.3109 33.1687 29.3377 33.1301 29.3535L24.0449 33.0693C23.696 33.2118 23.3047 33.2118 22.9557 33.0693L14.2086 29.5221C14.0337 29.451 13.8464 29.415 13.6575 29.416C13.4686 29.417 13.2817 29.4552 13.1076 29.5282L4.16194 33.279C4.13007 33.2923 4.09539 33.2977 4.06094 33.2946C4.02649 33.2915 3.99333 33.28 3.9644 33.2612C3.93547 33.2423 3.91165 33.2167 3.89503 33.1865C3.87842 33.1563 3.86953 33.1226 3.86914 33.0882V15.9622C3.86905 15.9211 3.88117 15.8808 3.90399 15.8465C3.92681 15.8121 3.95931 15.7853 3.99741 15.7692L13.0937 11.9037C13.2719 11.828 13.4636 11.7891 13.6573 11.7891C13.851 11.7891 14.0427 11.828 14.2208 11.9037L20.2101 14.4371",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 11.7754V29.4116",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 33.1812V20.5918",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1969 12.3826C28.5547 12.3826 29.6554 11.2795 29.6554 9.91883C29.6554 8.55814 28.5547 7.45508 27.1969 7.45508C25.839 7.45508 24.7383 8.55814 24.7383 9.91883C24.7383 11.2795 25.839 12.3826 27.1969 12.3826Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0138 19.0319C27.0615 19.0879 27.1211 19.1329 27.1882 19.1637C27.2553 19.1944 27.3284 19.2101 27.4023 19.2098C27.4762 19.2094 27.5491 19.1929 27.6159 19.1615C27.6827 19.1301 27.7418 19.0845 27.789 19.028C29.1035 17.4568 33.3159 13.2707 33.3159 9.83222C33.3159 5.7282 30.0076 3.78711 27.4042 3.78711C24.4762 3.78711 21.3809 5.89458 21.3809 9.83222C21.3809 13.2707 25.6752 17.4674 27.0138 19.0319Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTripsCount);
export default __webpack_public_path__ + "static/media/ic_trips_count.09482bba22b97276e8f1e90054dff635.svg";
export { ForwardRef as ReactComponent };